import "./TableComponent.scss";

const TableComponent = ({ columns, data, title = "", gap = "" }) => {
    return (
        <div className="tableContainer" style={{ gap: `${gap}` }}>
            {title && (
                <header>
                    {title && <h2>{title}</h2>}
                </header>
            )}
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr >
                            {columns.map((col, index) => (
                                <th style={{textAlign:"center"}} key={index}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td style={{ width: "5%", textAlign: "center" }}>{index + 1}</td>
                                {Object.values(row).map((value, i) => (
                                    <td key={i}>{value}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableComponent;

